import React, { Component, useLayoutEffect, useRef } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect } from "react";
import { useSelector } from "react-redux";

am4core.useTheme(am4themes_animated);

const CompareYeildDataProduction = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  // const dispatch = useDispatch();
  const chart = useRef(null);
  useLayoutEffect(() => {
    // Themes end

    // Create chart
    let x = am4core.create("chartdiv4", am4charts.XYChart);
    x.colors.step = 2;

    x.legend = new am4charts.Legend();
    x.legend.position = "top";
    x.legend.paddingBottom = 20;
    x.legend.labels.template.maxWidth = 95;

    let xAxis = x.xAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = "category";
    xAxis.renderer.cellStartLocation = 0.1;
    xAxis.renderer.cellEndLocation = 0.9;
    xAxis.renderer.grid.template.location = 0;

    let yAxis = x.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = 0;

    function createSeries(value, name) {
      let series = x.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = value;
      series.dataFields.categoryX = "category";
      series.name = name;

      series.events.on("hidden", arrangeColumns);
      series.events.on("shown", arrangeColumns);

      let bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.dy = 30;
      bullet.label.text = "{valueY}";
      bullet.label.fill = am4core.color("#ffffff");

      return series;
    }

    x.data = [
      {
        category: "Place #1",
        first: 40,
        second: 55,
        third: 60,
      },
      {
        category: "Place #2",
        first: 30,
        second: 78,
        third: 69,
      },
      {
        category: "Place #3",
        first: 27,
        second: 40,
        third: 45,
      },
      {
        category: "Place #4",
        first: 50,
        second: 33,
        third: 22,
      },
    ];

    createSeries("first", "The Thirst");
    createSeries("second", "The Second");
    createSeries("third", "The Third");

    function arrangeColumns() {
      let series = x.series.getIndex(0);

      let w =
        1 -
        xAxis.renderer.cellStartLocation -
        (1 - xAxis.renderer.cellEndLocation);
      if (series.dataItems.length > 1) {
        let x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
        let x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
        let delta = ((x1 - x0) / x.series.length) * w;
        if (am4core.isNumber(delta)) {
          let middle = x.series.length / 2;

          let newIndex = 0;
          x.series.each(function (series) {
            if (!series.isHidden && !series.isHiding) {
              series.dummyData = newIndex;
              newIndex++;
            } else {
              series.dummyData = x.series.indexOf(series);
            }
          });
          let visibleCount = newIndex;
          let newMiddle = visibleCount / 2;

          x.series.each(function (series) {
            let trueIndex = x.series.indexOf(series);
            let newIndex = series.dummyData;

            let dx = (newIndex - trueIndex + middle - newMiddle) * delta;

            series.animate(
              { property: "dx", to: dx },
              series.interpolationDuration,
              series.interpolationEasing
            );
            series.bulletsContainer.animate(
              { property: "dx", to: dx },
              series.interpolationDuration,
              series.interpolationEasing
            );
          });
        }
      }
    }

    x.logo.opacity = 0;
    x.logo.display = "none";
    x.logo.color = "white";
    x.logo.height = 25;
    x.logo.width = 5;

    if (
      (window.document.documentElement.lang === "fa") &
      (window.document.documentElement.dir === "rtl")
    ) {
      x.rtl = true;
      // console.log("chart is rtl");
    } else {
      x.rtl = false;
      // console.log("chart is ltr");
    }
    // chart.rtl = window.document.documentElement.lang === "fa" ? true : false;
    x.responsive.enabled = true;

    x.exporting.menu = new am4core.ExportMenu();
    x.exporting.menu.height = -25;
    x.exporting.menu.align = "left";
    x.exporting.menu.verticalAlign = "bottom";
    x.exporting.menu.items = [
      {
        label: "...",
        menu: [
          {
            label: "Image",
            menu: [
              { type: "png", label: "PNG" },
              { type: "jpg", label: "JPG" },
              { type: "svg", label: "SVG" },
              { type: "pdf", label: "PDF" },
            ],
          },
          {
            label: "Data",
            menu: [
              { type: "json", label: "JSON" },
              { type: "csv", label: "CSV" },
              { type: "xlsx", label: "XLSX" },
              { type: "html", label: "HTML" },
              { type: "pdfdata", label: "PDF" },
            ],
          },
          {
            label: "Print",
            type: "print",
          },
        ],
      },
    ];
    x.exporting.filePrefix = Date();
    chart.current = x;

    return () => {
      x.dispose();
    };
  });

  return <div id="chartdiv4" style={{ height: "400px", width: "100%" }}></div>;
};

export default CompareYeildDataProduction;
